module.exports = __webpack_public_path__ + "static/media/titan_light.3421fc62.svg";